// extracted by mini-css-extract-plugin
module.exports = {"ReviewsPage":"reviewsPage_ReviewsPage__wKwZ9","inner":"reviewsPage_inner__Rw5Tj","breadcrumbs":"reviewsPage_breadcrumbs__XZTVN"};